import { Injectable } from '@angular/core';
import { RunEffectsOnSemanticRouteService } from '@core/feature';
import { MyAccountActions } from '@my-account/data-access';
import { Actions, createEffect, EffectNotification, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class PersonalManagerConfirmationEffects {
  reloadManagerAfterApproveSuccess$: Observable<MyAccountActions.GetPersonalManagerConfirmation> = createEffect(() =>
    this.actions$.pipe(
      ofType(MyAccountActions.APPROVE_PERSONAL_MANAGER_SUCCESS),
      map((action: MyAccountActions.ApprovePersonalManagerSuccess) => action.personalManagerId),
      map((personalManagerId) => {
        return new MyAccountActions.GetPersonalManagerConfirmation(personalManagerId);
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private runEffectsOnSemanticRouteService: RunEffectsOnSemanticRouteService,
  ) {}

  ngrxOnRunEffects(resolvedEffects$: Observable<EffectNotification>): Observable<EffectNotification> {
    return this.runEffectsOnSemanticRouteService.ngrxOnRunEffectsOnSemanticRoute(
      (semanticRoute) => semanticRoute === 'assignManager',
    )(resolvedEffects$);
  }
}
